import React from 'react';

export interface TournamentFiltersState {
  name: string;
  startDate: string;
  endDate: string;
  state: string;
  city: string;
  status: string;
}

export interface TournamentFiltersProps {
  filters: TournamentFiltersState;
  states: string[];
  cities: string[];
  onChange: (filters: TournamentFiltersState) => void;
}

const TournamentFilters: React.FC<TournamentFiltersProps> = ({
  filters,
  states,
  cities,
  onChange,
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    onChange({ ...filters, [name]: value });
  };

  return (
    <div className="row g-2 mb-3">
      <div className="col-md-3">
        <label htmlFor="name" >Nome do torneio</label>
        <input
          type="text"
          name="name"
          value={filters.name}
          onChange={handleChange}
          className="form-control"
          placeholder="Pesquisa"
        />
      </div>
      <div className="col-md-2">
        <label htmlFor="startDate">Data Início</label>
        <input
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={handleChange}
          className="form-control"
        />
      </div>
      <div className="col-md-2">
        <label htmlFor="endDate">Data Fim</label>
        <input
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={handleChange}
          className="form-control"
        />
      </div>
      <div className="col-md-2">
        <label htmlFor="state">Estado</label>
        <select
          name="state"
          value={filters.state}
          onChange={handleChange}
          className="form-select form-select-lg"
        >
          <option value="">Selecione</option>
          {states.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-2" style={{ minWidth: 220 }}>
        <label htmlFor="city">Cidade</label>
        <select
          name="city"
          value={filters.city}
          onChange={handleChange}
          className="form-select form-select-lg"
        >
          <option value="">Selecione</option>
          {cities.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-1">
        <label htmlFor="status">Status</label>
        <select
          name="status"
          value={filters.status}
          onChange={handleChange}
          className="form-select form-select-lg"
        >
          <option value="">Selecione</option>
          <option value="active">Ativo</option>
          <option value="inactive">Inativo</option>
        </select>
      </div>
    </div>
  );
};

export default TournamentFilters;
